var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDzen = function SvgDzen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.326 8.326c-1.08 1.115-1.159 2.504-1.252 5.549 2.838 0 4.797-.01 5.809-.992.982-1.012.992-3.064.992-5.81-3.045.099-4.434.173-5.55 1.253M.125 7.074c0 2.745.01 4.797.992 5.809 1.012.982 2.971.992 5.81.992-.099-3.045-.173-4.434-1.253-5.55C4.56 7.246 3.17 7.168.125 7.075M6.926.125c-2.833 0-4.797.01-5.809.992C.135 2.129.125 4.181.125 6.927c3.045-.099 4.434-.173 5.55-1.253C6.754 4.56 6.832 3.17 6.925.125m1.4 5.55C7.246 4.558 7.167 3.17 7.074.124c2.838 0 4.797.01 5.809.992.982 1.012.992 3.064.992 5.81-3.045-.099-4.434-.173-5.55-1.253"
  })));
};
export default SvgDzen;